import { useState } from "react";
import { ProgressBar, Button, Container, Row, Col, ListGroup, Card, Form } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import CustomProgressBar from "views/Components/CustomProgressBar ";
export default function CampaignProgress() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [message, setMessage] = useState("");
  const [progress, setProgress] = useState(50); // Example progress
  const totalMessages = 160;
  const contacts = [
    "Contact 1", "Contact 2", "Contact 3", "Contact 4", "Contact 5",
    "Contact 6", "Contact 7", "Contact 8", "Contact 9", "Contact 10", "Contact 11"
  ];

  const [selectedContact, setSelectedContact] = useState(null);
  const [messages, setMessages] = useState({});
  const [newMessage, setNewMessage] = useState("");

  const sendMessage = () => {
    if (newMessage.trim() && selectedContact) {
      setMessages(prev => ({
        ...prev,
        [selectedContact]: [...(prev[selectedContact] || []), newMessage]
      }));
      setNewMessage("");
    }
  };
  return (
    <Container fluid className="vh-100 py-2 px-5">
      {/* Header */}
      <p
        className="text-muted mb-2"
        style={{ cursor: "pointer", fontWeight: "600" }}
        onClick={() => navigate("/admin/campaign-overview")}
      >
        &larr; Back to Campaigns
      </p>
      <h2 style={{ fontWeight: "700" }} className="mb-4 mt-0">XYZ Campaign Progress</h2>

      {/* Progress Bar */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <p className="fw-bold mb-0" style={{ fontWeight: "700" }}>Progress</p>
        <small style={{ fontWeight: "700" }}>{progress}/{totalMessages}</small>
      </div>
      <CustomProgressBar
        progress={progress}
        max={totalMessages}
        height="16px"
        fillColor="#004992"
        backgroundColor="#BFDFFF"
        borderRadius="20px"
        className="w-100 mb-4"
      />

      {/* Main Section */}
      <p className="fw-bold mb-3" style={{ fontWeight: "700" }}>Contacts</p>
      <Row>
        <Col md={3}>
          <Card className="rounded shadow p-3">
            {contacts.map((contact, index) => (
              <p
                key={index}
                style={{ cursor: "pointer", marginBottom: "8px", fontWeight: selectedContact === contact ? "900" : "600" }}
                onClick={() => setSelectedContact(contact)}
              >
                {contact}
              </p>
            ))}
          </Card>
        </Col>

        {/* Message Panel */}
        <Col md={9} className="d-flex flex-column">
          <Card className="rounded shadow-sm flex-grow-1 mb-2">
            <Card.Body className="overflow-auto">
              {/* Optional: Message thread here */}
              {selectedContact && messages[selectedContact]?.map((msg, i) => (
                <div key={i} className="bg-primary text-white p-2 rounded my-1" style={{ maxWidth: "60%" }}>
                  {msg}
                </div>
              ))}
            </Card.Body>
          </Card>

          {/* Message Input & Send */}
          <Form className="d-flex">
            <Form.Control
              type="text"
              placeholder="Message Here"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              className="mr-5"
              style={{ borderRadius: "6px", border: "2px solid #c7c7c7", }}
            />
            <Button
              variant="primary"
              onClick={sendMessage}
              style={{
                backgroundColor: "#004992",
                borderColor: "#004992",
                borderRadius: "6px",
                padding: "10px 30px",
              }}
            >
              Send
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}